<script>
  import Btn from "@/components/atoms/Btn";

  export default {
    components: { Btn },
    props: ["order"],
    data(){
      return {
        steps: {
          ["PENDING"]: 0,
          ["CONFIRMED"]: 1,
          ["DESIGN_CHECK"]: 2,
          ["FABRICATION"]: 3,
          ["SHIPPING"]: 4,
          ["DELIVERED"]: 5,
          ["CANCELED"]: 6
        }
      }
    },
    computed: {
      activeStep(){
        if(this.order && this.order.milestones){
          if(this.order.milestones.canceledAt){
            return this.steps["CANCELED"]
          }else if(this.order.milestones.deliveredAt){
            return this.steps["DELIVERED"]
          }else if(this.order.milestones.shippedAt){
            return this.steps["SHIPPING"]
          }else if(this.order.milestones.fabricatedAt){
            return this.steps["FABRICATION"]
          }else if(this.order.milestones.designCheckedAt){
            return this.steps["DESIGN_CHECK"]
          }else if(this.order.milestones.orderPlacedAt){
            return this.steps["CONFIRMED"]
          }else{
            return this.steps["PENDING"]
          }
        }else{
          return this.steps["PENDING"]
        }
      },
      orderPlacedAt(){
        return this.getDate(this.order.milestones && this.order.milestones.orderPlacedAt, "CONFIRMED");
      },
      designCheckedAt(){
        return this.getDate(this.order.milestones && this.order.milestones.designCheckedAt, "DESIGN_CHECK");
      },
      fabricatedAt(){
        return this.getDate(this.order.milestones && this.order.milestones.fabricatedAt, "FABRICATION");
      },
      shippedAt(){
        return this.getDate(this.order.milestones && this.order.milestones.shippedAt, "SHIPPING");
      },
      deliveredAt(){
        return this.getDate(this.order.milestones && this.order.milestones.deliveredAt, "DELIVERED");
      },
      canceledAt(){
        return this.getDate(this.order.milestones && this.order.milestones.canceledAt, "CANCELED");
      },
      heading(){
        if(this.activeStep == this.steps["CANCELED"]){
          return "Your order was canceled"
        }else if(this.activeStep == this.steps["DELIVERED"]){
          return "Your order was delivered!"
        }else if(this.activeStep == this.steps["SHIPPING"]){
          return "Your order is on its way!"
        }else{
          return "We're processing your order"
        }
      }
    },
    methods: {
      getDate(utc, status){
        const step = this.steps[status];
        if(this.activeStep >= step && utc){
          const date = new Date(utc)
          return `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
        }else if(this.activeStep + 1 == step && this.activeStep != this.steps["DELIVERED"]){
          return "In Progress"
        }else{
          return ""
        }
      },
    }
  }
</script>

<template>
  <div class="order-status">
    <div class="confirmation-status">
      {{heading}}
    </div>
    <div class="confirmation-number">
      Confirmation #<span v-if="order">{{order.confirmation}}</span>
    </div>
    <div class="columns">
      <div class="left">
        <div class="shipping-estimate" v-if="!canceledAt && !deliveredAt">
          Estimated delivery: 2-3 weeks
        </div>
        <div class="milestones" v-if="canceledAt">
          <div class="milestone" :class="{active: this.steps['CANCELED'] <= activeStep}" >
            <span class="dot fa fa-circle"></span>
            <span class="label">Canceled</span>
            <span class="date">{{canceledAt}}</span>
          </div>
        </div>
        <div class="milestones" v-else>
          <div class="milestone" :class="{active: this.steps['CONFIRMED'] <= activeStep}">
            <span class="dot fa fa-circle"></span>
            <span class="label">Order Placed</span>
            <span class="date">{{orderPlacedAt}}</span>
          </div>
          <div class="milestone" :class="{active: this.steps['DESIGN_CHECK'] <= activeStep}">
            <span class="dot fa fa-circle"></span>
            <span class="path"></span>
            <span class="label">Design Check</span>
            <span class="date">{{designCheckedAt}}</span>
          </div>
          <div class="milestone" :class="{active: this.steps['FABRICATION'] <= activeStep}">
            <span class="dot fa fa-circle"></span>
            <span class="path"></span>
            <span class="label">Fabrication</span>
            <span class="date">{{fabricatedAt}}</span>
          </div>
          <div class="milestone" :class="{active: this.steps['SHIPPING'] <= activeStep}">
            <span class="dot fa fa-circle"></span>
            <span class="path"></span>
            <span class="label">Order Shipped</span>
            <span class="date">{{shippedAt}}</span>
          </div>
          <div class="milestone" :class="{active: this.steps['DELIVERED'] <= activeStep}" >
            <span class="dot fa fa-circle"></span>
            <span class="path"></span>
            <span class="label">Delivered</span>
            <span class="date">{{deliveredAt}}</span>
          </div>
        </div>
        <div class="support">
          For questions regarding your order email: <br>
          Support@quadrobee.com
        </div>
      </div>
      <div class="right" v-if="!$store.get('usingMobile')">
        <div class="image-col" v-if="this.order">
          <img class="image" :src="this.order.imageUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "~@/styles/constants";
.order-status { 
  background-color: $black_2;
  border-radius: 0.25rem;
  box-shadow: $z_depth_2;
  padding: 3rem 3.5rem;
  .confirmation-number { 
    font-size: 1.5rem;
    margin-bottom: 1rem;
    span { 

    }
  }

  .confirmation-status { 
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .columns{
    display: flex;
    align-items: center;
    .left{
      flex: 1;
    }
    .right{
      .image-col{
        width: 20rem;
        border-radius: 6px;
        img{
          width: 100%;
          filter: brightness(2.5);
        }
      }
    }
  }

  .shipping-estimate { 
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }

  .milestones { 
    margin-bottom: 1.5rem;
    .milestone { 
      height: 24px;
      margin: 1rem 0rem;
      position: relative;
      display: flex;
      align-items: center;
      &.active{
        .dot {
          color: $p;
        }
        .path { 
          background-color: $p;
        }
      }
      .dot { 
        margin-right: 1rem;
        color: $w_1;
        z-index: 1;
      }
      .path { 
        z-index: 0;
        position: absolute;
        top: -1.5rem;
        left: 6px;
        width: 3px;
        height: 2.5rem;
        background-color: $w_1;
      }
      .label { 
        font-size: 1.25rem;
        margin-right: 1rem;
      }
      .date { 
        color: $w_1;
      }
    }
  }

  .support { 

    br { 

    }
  }
}
</style>